import React, { useEffect, useState } from "react";
import { Minus, Plus, Search, ShoppingCart, Download, X } from "lucide-react";
// import { toast } from "react-toastify";
import { useProductStore } from "../../store/useProductStore";
import { useAuthStore } from "../../store/useAuthStore";
import ProductModal from "./ProductModal"; // Import the ProductModal component
import { Pagination, Stack } from "@mui/material";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { useDebounce } from "../../hooks/useDebounce";
import orderServices from '../../services/order.service';

const titles = [
  "Part number",
  "Category",
  // "Total Current sales of last 3 months",
]

const categories = [
  {value: 1, label: 'A'},
  {value: 2, label: 'B'},
  {value: 3, label: 'C'},
]

const ProductTable = () => {
    const { user } = useAuthStore();
    const USER_ROLE = user?.userDataObj?.role;
    const { fetchProducts, setCartCount, fetchSkuMakeandSegment, downloadInventory, fetchPartNumber } = useProductStore();
    const [products, setProducts] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [totalCount, setTotalCount] = useState(null);
    const [months,setMonths] = useState({})
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const cartCount = useProductStore((state) => state.cartCount);
    const [searchTerm, setSearchTerm] = useState("");
    const [distributorId, setDistributorId] = useState("");
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const [searchResults, setSearchResults] = useState([]);
    const [distributorList, setDistributorList] = useState([]);
    const [filter, setFilter] = useState({
        limit: 10,
        offset: 1,
        make_id: "",
        segment_id: "",
        size_id: "",
        skuNameAndPartNoSearch: "",
        category_id: null
    })
    const [isLoading, setIsLoading] = useState(false);

    const [make, setMake] = useState([])
    const [size, setSize] = useState([])
    const [segment, setSegment] = useState([])

    // Get cart data from localStorage (product_data)
    const getCartData = () => {
        return JSON.parse(localStorage.getItem("product_data")) || [];
    };

    const fetchData = async (filter) => {
        setIsLoading(true);
        const res = await fetchProducts(filter);

        if (res.status) {
            setTotalPages(res.data.pagination.totalPages);
            setTotalCount(res.data.count);
            setProducts(res.data.rows);
            setMonths(res.data.monthName)
        } else {
            setTotalPages(1);
            setTotalCount(0);
            setProducts([]);
        }
        setIsLoading(false);
    };

    const handleDownload = async (filter) => {
      setIsLoading(true);
      const res = await downloadInventory(filter);

      if (res.status) {
          console.log(res)
      } else if(res?.data?.statusText === 
        "Not Found") {
          toast.error('Data Not Found', {toastId: 'errorMessageDownload'})
        } 
      else {
          toast.error('Failed to download', {toastId: 'errorMessageDownload'})
      }
      setIsLoading(false);
  };

    const fetchSkuMakeandSegmentData = async () => {
        const res = await fetchSkuMakeandSegment();

        if (res.status) {
            const { make, segment, size } = res.data;
            setMake(make);
            setSegment(segment);
            setSize(size);
        } else {
            setMake([]);
            setSegment([]);
            setSize([]);
        }

    };

    // State to manage cart data
    const [cartData, setCartData] = useState(getCartData());

    useEffect(() => {
        // Update cart count whenever cartData changes
        setCartCount(cartData.filter(value => value?.ordered_quantity > 0).length);
    }, [cartData, setCartCount]);

    // Get the product quantity from the cart
    const getProductQuantity = (productId) => {
        const product = cartData.find((item) => item.product_id === productId);
        return product ? product.ordered_quantity : -1;
    };

    // Handle Add to Cart
    const handleAddToCart = (product) => {      
        const updatedCart = [
            ...cartData,
            { ...product, ordered_quantity: 1, product_id: product.id },
        ];
        localStorage.setItem("product_data", JSON.stringify(updatedCart));
        setCartData(updatedCart);
    };

    // Increase quantity of a product in the cart
    const handleIncrease = (productId) => {
        const updatedCart = cartData.map((item) =>
            item.product_id === productId 
                ? { ...item, ordered_quantity: (item.ordered_quantity + 1) > 1000 ? 1000 : (item.ordered_quantity + 1) }
                : item
        );        
        localStorage.setItem("product_data", JSON.stringify(updatedCart));
        setCartData(updatedCart); // Update cart data in state
    };

    const handleInputChange = (value, productId) => {
      // console.log("value, productId",value, productId);

      if (value > 1000) {
            toast.dismiss();
            return toast.info('Quantity exceed. Maximum allowed 1000.', { toastId: 'quantityLimit' });
          }
      
      if (value === "") {
        const updatedCart = cartData.map((item) =>
          item.product_id === productId
              ? { ...item, ordered_quantity: 0 }
              : item
      );
      localStorage.setItem("product_data", JSON.stringify(updatedCart));
      setCartData(updatedCart);
      } else {
        const newQuantity = Math.max(0, parseInt(value, 10) || 0);
        const updatedCart = cartData.map((item) =>
          item.product_id === productId
              ? { ...item, ordered_quantity: newQuantity }
              : item
      );
      localStorage.setItem("product_data", JSON.stringify(updatedCart));
      setCartData(updatedCart);
      }
    };

    // Decrease quantity of a product in the cart
    const handleDecrease = (productId) => {
        const updatedCart = cartData
            .map((item) =>
                item.product_id === productId
                    ? {
                        ...item,
                        ordered_quantity: Math.max(-1, item.ordered_quantity - 1),
                    }
                    : item
            )
            .filter((item) => item.ordered_quantity > 0); // Remove items with 0 quantity
        localStorage.setItem("product_data", JSON.stringify(updatedCart));
        setCartData(updatedCart); // Update cart data in state
    };

    const handleConfirmOrder = () => {
        // if (cartData.length === 0) {
        //   toast.error(
        //     "Your cart is empty. Please add products before confirming the order."
        //   );
        // } else {
        //   setIsModalOpen(true);
        // }
        const totalOrder = (cartData || []).reduce((accum, item) => accum + (item.ordered_quantity * item.no_of_sets || 0), 0);
        console.log(totalOrder, "totalOrder")
        if (totalOrder < 24) {
          toast.info("Minimum order requirement: 24 sets. Please add more items to proceed.",{ toastId: 'totalOrderLimit' });
          return;
        }
        if(USER_ROLE === 5 && !distributorId) {
          toast.info("Please select a distributor before confirming the order.", { toastId: 'distributorError' });
          return;
        }
        setIsModalOpen(true);
    };

    const getAvailability = (stock_quantity) => {
        // Logic for determining availability status based on stock quantity
        if (stock_quantity > 500) {
            return {
                status: "In Stock",
                bgClass: "bg-emerald-100 text-emerald-800", // Green background for "In Stock"
            };
        } else if (stock_quantity > 0 && stock_quantity <= 500) {
            return {
                status: "Limited Stock",
                bgClass: "bg-orange-100 text-orange-800", // Orange background for "Limited Stock"
            };
        } else {
            return {
                status: "Available Soon",
                bgClass: "bg-red-100 text-red-800", // Red background for "Available Soon"
            };
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setFilter({ ...filter, offset: pageNumber })
    };

    const handleSearch = () => {
        const { make_id, skuNameAndPartNoSearch, segment_id, size_id, category_id } = filter;
        if (skuNameAndPartNoSearch == "" && segment_id == "" && make_id == "" && size_id == "" && category_id === null) {
            return;
        }

        setCurrentPage(1);
        filter.offset = 1;
        fetchData(filter);
    }

    const handleReset = () => {
        setFilter({
            limit: 10,
            offset: 1,
            make_id: "",
            segment_id: "",
            size_id: "",
            skuNameAndPartNoSearch: "",
            category_id: null
        })
        setCurrentPage(1)
        fetchData({ limit: 10, offset: 1});
    }

    const handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        fetchData({...filter, offset : 1});
        setFilter({ ...filter, offset: 1 });
        setCurrentPage(1);
        setSearchResults([]);
      }
  };

    useEffect(() => {
        fetchData(filter);
    }, [currentPage]);

    useEffect(() => {
      fetchData({...filter, offset : 1});
      setFilter({ ...filter, offset: 1 })
      setCurrentPage(1);
  }, [filter.category_id, filter.make_id, filter.segment_id, filter.size_id]);

    useEffect(() => {
        fetchSkuMakeandSegmentData();
    }, []);

    useEffect(() => {
        const fetchDistributorList = async () => {
          const res = await orderServices.getDistiributorlList();
          if (res.status) {
            const distributors = res.data.map((item) => ({
              value: item?.user_id,
              label: item?.distributor_name,
            }));
            setDistributorList(distributors);
          } else {
            setDistributorList([]);
          }
        };
        if(USER_ROLE === 5) {
        fetchDistributorList();
        }
    }, [])

    const fetchPartNumberData = async (debouncedSearchTerm) => {
      const body = {
        part_no : debouncedSearchTerm
      }
      const res = await fetchPartNumber(body);
      if (res.status) {
       if (res.data?.length > 1) {
        setSearchResults(res.data);
      }else {
        setSearchResults([]);
      }
      } else {
          setSearchResults([]);
      }
  };

    useEffect(() => {
      if (debouncedSearchTerm) {
          fetchPartNumberData(debouncedSearchTerm);
      }
  }, [debouncedSearchTerm]);

    console.log(cartData, "cartData")

      if(isLoading){
        return <Loader />
      }

    return (
      <>
        <div className="overflow-x-auto">
         { USER_ROLE === 4 && <div className="flex justify-end mb-4">
            <button
              onClick={() => handleDownload(filter)}
              className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-emerald-600 bg-emerald-100 rounded-md hover:bg-emerald-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 mt-1 mr-1"
            >
              <Download className="mr-1.5 h-3 w-3" />
              Download Inventory
            </button>
          </div>}
          {USER_ROLE === 5 && <div className="flex items-center gap-2">
            <h6 className="font-bold">Select Distributor:</h6>
          <select className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto"
            value={distributorId}
                          onChange={(e) => setDistributorId(e.target.value)}>
            <option value="">Select Distributor</option>
            {/* <option value=" ">All Segment</option> */}
            {
              distributorList.map((data) => {
                return <option key={data.value} value={data.value}>{data.label}</option>
              })
            }
                          {/* {
                              segment.map((data) => {
                                  return <option key={data.id} value={data.id}>{data.segment}</option>
                              })
                          } */}

          </select>
          </div>}
          <h5>Filters:</h5>
          <div className="flex flex-col md:flex-row items-center mb-4 space-y-2 md:space-y-0 md:space-x-4">
            <div className="relative w-full md:w-[600px]">
              <Search className="absolute left-1 top-2 h-5 w-5 text-gray-400" />
              <input
                type="text"
                value={filter.skuNameAndPartNoSearch}
                onChange={(e) => {
                  if (searchTerm !== e.target.value) setSearchTerm(e.target.value);
                  setFilter({ ...filter, skuNameAndPartNoSearch: e.target.value })}
                }
                onKeyUp={handleKeyPress}
                placeholder="Search by Part Number"
                className="w-full pl-8 pr-1 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
              />

              {searchResults.length > 0 && searchTerm && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                  {searchResults.map((result, index) => (
                    <div
                      key={index}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => {
                        setFilter(prev => ({ ...prev, skuNameAndPartNoSearch: result.part_no }));
                        fetchData({...filter, skuNameAndPartNoSearch: result.part_no});
                        setSearchResults([]);
                      }}
                    >
                      {result.part_no}
                    </div>
                  ))}
                </div>
              )}

            </div>

            <div className="flex flex-col md:flex-row md:items-center w-full">
              <div className="grid grid-cols-1 md:flex md:space-x-2 w-full gap-1 custom-grid">
                            <select className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto"
                  value={filter.segment_id}
                                onChange={(e) => setFilter({ ...filter, segment_id: e.target.value })}>
                  <option value="">All Segment</option>
                  {/* <option value=" ">All Segment</option> */}
                                {
                                    segment.map((data) => {
                                        return <option key={data.id} value={data.id}>{data.segment}</option>
                                    })
                                }

                </select>
                            <select className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto" value={filter.size_id}
                                onChange={(e) => setFilter({ ...filter, size_id: e.target.value })}>
                  <option value="">All Size</option>
                  {/* <option value=" ">All Size</option> */}
                                {
                                    size.map((data) => {
                                        return <option key={data.id} value={data.id}>{data.size}</option>
                                    })
                                }
                </select>

                            <select className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto" value={filter.make_id}
                                onChange={(e) => setFilter({ ...filter, make_id: e.target.value })}>
                  <option value="">All Make</option>
                  {/* <option value=" ">All Make</option> */}
                                {
                                    make.map((data) => {
                                        return <option key={data.id} value={data.id}>{data.make}</option>
                                    })
                                }
                </select>
                {USER_ROLE == 4 && <select className="border border-gray-300 rounded-lg px-2 py-1 w-full md:w-auto" value={filter.category_id}
                                          onChange={(e) => setFilter({ ...filter, category_id: e.target.value })}>
                            <option value="">All Category</option>
                            {/* <option value=" ">All Category</option> */}
                                          {
                                              categories.map((category,i) => {
                                                  return <option key={i} value={category.value}>{category.label}</option>
                                              })
                                          }
                          </select>}

                            {/* <button className="w-full md:w-auto px-2 py-1 bg-emerald-500 text-white text-sm rounded hover:bg-emerald-600 transition" onClick={handleSearch}>
                  Apply
                </button> */}

                <button
                                className="w-full md:w-auto px-2 py-1 border-2 border-gray-300 text-gray-800 rounded-lg hover:bg-gray-50" onClick={handleReset}>
                  Reset
                </button>

                {(cartCount > 0 && (USER_ROLE === 3 || USER_ROLE === 5))  && (
                    <div className="flex justify-end w-full">
                        <button
                        onClick={handleConfirmOrder}
                        className="flex items-center px-4 py-2 bg-emerald-300 text-gray-800 rounded-lg hover:bg-primary-dark transition whitespace-nowrap"
                        >
                        Confirm Order
                        <div className="relative flex items-center ml-2">
                            <ShoppingCart className="h-6 w-6 text-gray-500" />
                            <span className="absolute -top-2 -right-2 bg-emerald-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                            {cartCount}
                            </span>
                        </div>
                        </button>
                    </div>
                    )}

              </div>
            </div>
          </div>

          <div className="overflow-auto h-[250px] sm:h-[400px] md:h-[450px] xl:h-[600px] rounded-lg">
            <table className="min-w-full overflow-auto divide-y divide-gray-200">
              <thead>
                <tr className="bg-emerald-200">
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Part number
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Segment
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Size
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Make
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    MRP Per Set (₹)
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Sets
                  </th>
                  {USER_ROLE === 4 && <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Availability
                  </th>}
                  {(USER_ROLE === 3 || USER_ROLE === 5) && <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Add to Cart ({(cartData || []).reduce((accum, item) => accum + (item.ordered_quantity * item.no_of_sets || 0), 0)})
                  </th>}
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Total MRP (₹)
                  </th>
                  {USER_ROLE === 4 && <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                    Production
                  </th>}
                  {USER_ROLE === 4 && <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                    Dispatched
                  </th>}
                  {USER_ROLE === 4 && <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                    Balance Sets
                  </th>}
                  {USER_ROLE === 4 && <th className="p-3 text-center text-sm font-bold text-gray-700 ">
                    Order Request
                  </th>}
                  {USER_ROLE === 4 &&
                    <>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                   Category
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                   Average sale of last 3 months
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                    Forecasting for {months?.nextMonthName} month
                  </th>
                  <th className="p-3 text-left text-sm font-bold text-gray-700 ">
                  Forecasting for {months?.afterNextMonthName} month
                  </th>
                  </>
                  }
                </tr>
              </thead>
                        {products.length != 0 ?
                            (<tbody className="bg-white divide-y divide-gray-200">
                  {products.map((product, index) => {
                    const quantity = getProductQuantity(product.id);
                                    const availability = getAvailability(product.available_stock);
                    return (
                      <tr
                        key={product.id}
                        className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                      >
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                          {product.part_no}
                        </td>
                        {/* <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                          {product?.totalQuantity ?? 'NA'}
                        </td> */}
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                          {product.segment_name}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                          {product.size}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800">
                          {product.make}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {product.default_mrp}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {product.no_of_sets}
                        </td>
                        {USER_ROLE === 4 && <td className="p-3 whitespace-nowrap">
                          <span
                            className={`px-2 inline-flex text-xs leading-5 rounded-full ${availability.bgClass}`}
                          >
                            {availability.status}
                          </span>
                        </td>}
                        {(USER_ROLE === 3 || USER_ROLE === 5) && <td className="p-3 whitespace-nowrap">
                                                {
                                                    quantity < 0 ? (
                            <button
                              className="px-3 py-1 bg-emerald-500 text-white text-sm rounded hover:bg-emerald-600"
                              onClick={() => handleAddToCart(product)}
                            >
                              Add to Cart
                            </button>
                          ) : (
                            <div className="flex items-center space-x-2">
                              {product?.no_of_sets} <X size={12} />
                              {/* <button
                                className="p-1 rounded bg-emerald-100 text-emerald-600 hover:bg-emerald-200"
                                onClick={() => handleDecrease(product.id)}
                              >
                                <Minus size={16} />
                              </button> */}
                              {/* <span className="text-sm font-medium">
                                {quantity}
                              </span> */}
                              <input
                                type="number"
                                className="w-12 text-center text-sm font-medium border 
                                rounded p-1 focus:outline-none focus:ring-2 focus:ring-emerald-400"
                                value={quantity}
                                onChange={(e) => handleInputChange(e.target.value, product.id)}
                                min="0"
                              />
                              {/* <button
                                className="p-1 rounded bg-emerald-100 text-emerald-600 hover:bg-emerald-200"
                                onClick={() => handleIncrease(product.id)}
                              >
                                <Plus size={16} />
                              </button> */}
                              &nbsp; = {cartData.find((item) => item.product_id === product.id)?.ordered_quantity * product.no_of_sets || 0}
                            </div>
                                                    )
                                                }
                        </td>}
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {product.no_of_sets * product.default_mrp * cartData.find((item) => item.product_id === product.id)?.ordered_quantity || 0}
                        </td>
                        {USER_ROLE === 4 && <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right" >
                           {product.total_stock}
                        </td>}
                        {USER_ROLE === 4 && <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                           {product.sent_stock}
                        </td>}
                        {USER_ROLE === 4 && <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                           {product.available_stock}
                        </td>}
                        {USER_ROLE === 4 && <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                           {product.total_order || 0}
                        </td>}
                        {USER_ROLE === 4 &&
                    <>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-center">
                         {product?.category ?? 'NA'}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {product?.averageQuantity ?? 'NA'}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {product?.nextMonthForecast ?? 'NA'}
                        </td>
                        <td className="p-3 whitespace-nowrap text-sm text-gray-800 text-right">
                          {product?.afterNextMonthForecast ?? 'NA'}
                        </td>
                        </>}
                      </tr>
                    );
                  })}
                            </tbody>) :
                            (<tbody>
                  <tr>
                                    <td className="p-3 whitespace-nowrap text-sm text-center text-gray-800" colSpan={8}>
                      No Products Available
                    </td>
                  </tr>

                            </tbody>)
                        }
              {/* <tfoot>
                            <tr>
                                <td className="p-3 whitespace-nowrap text-sm text-left text-gray-800" colSpan={8}>
                                    Page {currentPage} Of {totalPages || 1}
                                </td>
                            </tr>

                        </tfoot> */}
            </table>

            {totalCount !== null && (
            <div className="flex justify-center my-2">
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(event, value) => handlePageChange(value)}
                  variant="outlined"
                  shape="rounded"
                  color="primary"
                  size="10"
                />
              </Stack>
            </div>
          )}
          </div>

          {/* {totalCount !== null && (
            <div className="flex justify-center mt-2">
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(event, value) => handlePageChange(value)}
                  variant="outlined"
                  shape="rounded"
                  color="primary"
                />
              </Stack>
            </div>
          )} */}
        </div>

        {isModalOpen && (
          <ProductModal
            closeModal={() => setIsModalOpen(false)}
            Close
            modal
            function
            distributorId={distributorId}
          />
        )}
      </>
    );
};

export default ProductTable;